import { useQuery } from "@tanstack/react-query";
import apiService from "../backend/api";

const useInvoices = (username) => {
  const query = useQuery({
    queryKey: ["invoices", username],
    queryFn: async () => {
      if (!username) return null;
      const data = await apiService.getUserInvoices(username);
      return data;
    },
    enabled: !!username,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return query;
};

export default useInvoices;
